import * as ActionTypes from './index';

export function changeNewUserNewPasswordForm(payload) {
    return {
        type: ActionTypes.CHANGE_NEW_USER_NEW_PASSWORD_FORM,
        payload: payload
    }
}

export function changeNewUserStoreSettings(payload) {
    return {
        type: ActionTypes.CHANGE_NEW_USER_STORE_SETTINGS,
        payload: payload
    }
}

export function openChangePasswordModal(payload) {
    return {
        type: ActionTypes.OPEN_CHANGE_PASSWORD_MODAL,
        payload: payload
    }
}

export function closeChangePasswordModal(payload) {
    return {
        type: ActionTypes.CLOSE_CHANGE_PASSWORD_MODAL,
        payload: payload
    }
}

export function openDeleteUserModal(payload) {
    return {
        type: ActionTypes.OPEN_DELETE_USER_MODAL,
        payload: payload
    }
}

export function closeDeleteUserModal(payload) {
    return {
        type: ActionTypes.CLOSE_DELETE_USER_MODAL,
        payload: payload
    }
}

export function deleteAragUser(payload) {
    return {
        type: ActionTypes.DELETE_ARAG_USER,
        payload: payload
    }
}

export function deleteAragUserSuccess(payload) {
    return {
        type: ActionTypes.DELETE_ARAG_USER_SUCCESS,
        payload: payload
    }
}

export function deleteAragUserFail(payload) {
    return {
        type: ActionTypes.DELETE_ARAG_USER_FAIL,
        payload: payload
    }
}

export function resetAragUserPassword(payload) {
    return {
        type: ActionTypes.RESET_ARAG_USER_PASSWORD,
        payload: payload
    }
}

export function resetAragUserPasswordSuccess(payload) {
    return {
        type: ActionTypes.RESET_ARAG_USER_PASSWORD_SUCCESS,
        payload: payload
    }
}

export function resetAragUserPasswordFail(payload) {
    return {
        type: ActionTypes.RESET_ARAG_USER_PASSWORD_FAIL,
        payload: payload
    }
}

//action that handles the damages per case type
export function handleSubCasesPerCaseType(payload) {
    return {
        type: ActionTypes.HANDLE_SUB_CASES_PER_CASE_TYPE,
        payload: payload
    }
}

export function changeNewUserProperties(property, data) {
	return {
		type: ActionTypes.CHANGE_NEW_USER_PROPERTIES,
		payload: {
			key: property,
			value: data
		}
	}
}

//action that requests POST new User
export function requestNewUser(newUser, token) {
	return {
		type: ActionTypes.REQUEST_NEW_USER,
		payload: {
			user: newUser
		}
	}
}

//action that updated the redux store with the new posted User after successful response
export function receivePostNewUserResponse(repsonse) {
	return {
		type: ActionTypes.RECEIVE_POST_NEW_USER_RESPONSE,
		payload: repsonse
	}
}

//action that receives bad request response from posting new User
export function receiveBadResponsePostNewUser(repsonse) {
	return {
		type: ActionTypes.RECEIVE_BAD_RESPONSE_POST_NEW_USER,
		payload: repsonse
	}
}

export function clearNewUser(){
	return{
		type: ActionTypes.CLEAR_NEW_USER
	}
}

//action that requests patches a User
export function requestEditUser(newUser) {
	return {
		type: ActionTypes.REQUEST_EDIT_USER,
		payload: {
			user: newUser
		}
	}
}

export function receivePatchUserResponse(repsonse) {
	return {
		type: ActionTypes.RECEIVE_PATCH_USER_RESPONSE,
		payload: repsonse
	}
}

export function receiveBadResponsePatchUser(repsonse) {
	return {
		type: ActionTypes.RECEIVE_BAD_RESPONSE_PATCH_USER,
		payload: repsonse
	}
}